import { useClient } from "#/hook/useClient";
import type { ActionIconProps } from "@mantine/core";
import { ActionIcon } from "@mantine/core";
import type { IconProps } from "@tabler/icons-react";
import clsx from "clsx";
import type React from "react";
import type { ComponentType } from "react";

export interface Props extends ActionIconProps {
  onClick?: React.MouseEventHandler<HTMLButtonElement>;
  icon: ComponentType<IconProps>;
}

const ActionButton = ({ icon: Icon, ...props }: Props) => {
  const { client } = useClient();
  const color = props.color ?? client?.color ?? "black";

  return (
    <ActionIcon
      radius={"xl"}
      size={"lg"}
      classNames={{
        root: clsx([
          "disabled:opacity-30!",
          "disabled:cursor-not-allowed",
          "disabled:data-[variant=outline]:bg-transparent",
          "transition-all duration-200",
        ]),
      }}
      {...props}
      color={color}
    >
      <Icon size={props.size === "xs" ? 10 : 20} stroke={2.5} />
    </ActionIcon>
  );
};

export default ActionButton;
